import { HuskyProposal, IProps } from 'lib/types'
import './huskyIvoBlock.scss'

const HuskyIvoBlock = ({ proposals }: IProps) => {

    const huskyProposal: HuskyProposal = proposals?.calculationData?.data?.huskyProposal;

    const huskyIvoModelLabel = "Husky IVO " + huskyProposal?.huskyIvoSpec?.sku;

    const huskyIvoModelImageCssClasses = "xsd__husky-ivo-image " +
                                         (huskyProposal?.huskyIvoSpec?.modelName.includes("HE150D") || huskyProposal?.huskyIvoSpec?.modelName.includes("HE350T") ? 
                                         " xsd__husky-ivo-image--D-or-T" : "");

    return (
        <div className="row g-0 msds-bg-gray-1 xsd__husky-ivo">
            <div className="col-12 col-xl-4 col-xxl-5 mb-6 mb-xl-0">
                <div className="msds-text-body-2-bold">{huskyIvoModelLabel}</div>

                <div className="mt-2 msds-text-body-2-bold">Quantity: {huskyProposal?.serverQuantity}</div>

                <div className={huskyIvoModelImageCssClasses}>
                    {/* Change the image source when the API/FELL are giving true URL paths for images from bynder/content portal */}
                    <img src={huskyProposal?.huskyIvoSpec?.imageUrl} alt={huskyProposal?.huskyIvoSpec?.modelName + ' image'} loading="lazy" />
                    <div className="xsd__husky-ivo-image-link msds-text-body-2">
                        <a href={huskyProposal?.huskyIvoSpec?.dataSheetLink} target="_blank" rel="noreferrer">
                            {huskyProposal?.huskyIvoSpec?.dataSheetLabel}
                        </a>
                    </div>
                </div>
            </div>

            <div className="col-12 col-xl-7 col-xxl-6">
                <div className="xsd__husky-ivo-tech-specs msds-text-body-2-bold mb-4">Technical specifications</div>
                <div className="xsd__husky-ivo-tech-specs">
                    <div>Form factor</div>
                    <div>{huskyProposal?.huskyIvoSpec?.formFactorLabel}</div>
                </div>
                <div className="xsd__husky-ivo-tech-specs">
                    <div>Processor type</div>
                    <div>{huskyProposal?.huskyIvoSpec?.processorType}</div>
                </div>
                <div className="xsd__husky-ivo-tech-specs">
                    <div>Operating system</div>
                    <div>{huskyProposal?.huskyIvoSpec?.operatingSystem}</div>
                </div>
                <div className="xsd__husky-ivo-tech-specs">
                    <div>Hard drive bays</div>
                    <div>{huskyProposal?.huskyIvoSpec?.storageTypeLabel}</div>
                </div>
                <div className="xsd__husky-ivo-tech-specs">
                    <div>Total disk capacity</div>
                    <div>{huskyProposal?.huskyIvoSpec?.storageCapacityLabel} </div>
                </div>
                <div className="xsd__husky-ivo-tech-specs">
                    <div>RAM</div>
                    <div>{huskyProposal?.huskyIvoSpec?.ram}</div>
                </div>
                <div className="xsd__husky-ivo-tech-specs">
                    <div>Operating system drive</div>
                    <div>{huskyProposal?.huskyIvoSpec?.osDrive}</div>
                </div>
            </div>
            <div className="col-12 msds-text-body-4 msds-bg-gray-1 mt-8">
                *All figures assume an even distribution of cameras (quantity, FPS, codec and resolution) across all Recording Servers.
            </div>
        </div>
    )
}

export default HuskyIvoBlock
